exports.components = {
  "component---src-templates-404-js": () => import("./../../../src/templates/404.js" /* webpackChunkName: "component---src-templates-404-js" */),
  "component---src-templates-netlify-forms-stub-js": () => import("./../../../src/templates/netlify-forms-stub.js" /* webpackChunkName: "component---src-templates-netlify-forms-stub-js" */),
  "component---src-templates-page-js": () => import("./../../../src/templates/page.js" /* webpackChunkName: "component---src-templates-page-js" */),
  "component---src-templates-redirect-page-js": () => import("./../../../src/templates/redirect-page.js" /* webpackChunkName: "component---src-templates-redirect-page-js" */)
}

